// extracted by mini-css-extract-plugin
export default {"uploadContainer":"EditProfile_uploadContainer__RTiTC","imageStyle":"EditProfile_imageStyle__Y7+Vl"};